import {
  setAppConfig as setAppConfigAction,
  GLOBALS,
  WP_BLOGS,
} from '@wix/communities-blog-client-common';
import { type CommonThunkArgs, type CommonThunkAction } from '@app/types/common-thunk-action.type';
import { type PlatformApi } from '../../controller/platform-api';
import getEnvironment from '../../services/get-environment';
import { type AppState } from '../../types';
import { getTopology } from '../topology/topology-selectors';

export function setAppConfig({ bundleName }: { bundleName: string }): CommonThunkAction<void> {
  return async (dispatch, getState, { platformApi, appParams }) => {
    dispatch(
      setAppConfigAction(
        getConfig({
          appParams,
          platformApi,
          state: getState(),
          bundleName,
        }),
      ),
    );
  };
}

function getConfig({
  appParams,
  platformApi,
  state,
  bundleName,
}: {
  appParams: CommonThunkArgs['appParams'];
  platformApi: PlatformApi;
  state: AppState;
  bundleName: string;
}) {
  const isProduction = process.env.NODE_ENV === 'production';
  const { isEditor, isPreview } = getEnvironment(platformApi);

  const topology = getTopology(state);

  const developmentConfig = {
    isDevMode: !isProduction,
  };
  const isSeo = platformApi.seo.isInSEO();
  const isWP = WP_BLOGS.includes(appParams.instanceId!);

  const { postPageSectionUrl } = topology;

  const clientConfig = {
    bundleName,
    imageHost: GLOBALS.MEDIA_IMAGE_HOST,
    videoHost: GLOBALS.MEDIA_VIDEO_HOST,
    instanceId: appParams.instanceId,
    duplexer: {
      url: GLOBALS.DUPLEXER_URL,
    },
    isInEditor: isEditor,
    isInPreview: isPreview,
    isWP,
    categoryPath: isWP ? 'category' : 'categories',
    useCategoryMenuLabelForMetadataTitle: isWP && !isSeo,
    postPageSectionUrl,
    ...developmentConfig,
  };

  return clientConfig;
}
